/**
 * Done. / ChiroCPD — StatusBadge Primitive
 *
 * Colour-coded pill badge for export field status.
 * Uses both colour AND icon/text to convey status (WCAG 1.4.1 — not colour alone).
 */

import { cx } from '@/lib/utils';
import type { ExportFieldStatus } from '@/lib/types';

interface StatusBadgeProps {
  status: ExportFieldStatus;
  label: string;
  className?: string;
}

const STATUS_STYLES: Record<ExportFieldStatus, string> = {
  complete: 'bg-[var(--color-success-100)] text-green-800',
  partial:  'bg-[var(--color-warning-100)] text-amber-800',
  empty:    'bg-[var(--surface-muted)] text-[var(--text-muted)]',
};

const STATUS_ICONS: Record<ExportFieldStatus, string> = {
  complete: '●',
  partial:  '◐',
  empty:    '○',
};

export function StatusBadge({ status, label, className }: StatusBadgeProps): React.ReactElement {
  return (
    <span
      className={cx(
        'inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium',
        STATUS_STYLES[status],
        className,
      )}
    >
      <span aria-hidden="true">{STATUS_ICONS[status]}</span>
      {label}
    </span>
  );
}
